<template>
  <div id="magazineLoadingBox" v-if="isLoading">
    <!-- Placeholder image or loading indicator -->
    <img class="d-none d-md-block mb-4" style="opacity:0.6;"
      src="/wp-content/themes/understrap-child/fidelio-templates/images/magazinePlaceholder.svg" alt="">
    <img class="d-md-none mb-4" style="opacity:0.6;"
      src="/wp-content/themes/understrap-child/fidelio-templates/images/magazinePlaceholderMobile.svg" alt="">
  </div>
  <div v-if="magazines && magazines.length" class="mb-4 py-1 rounded-corners-10">
    <div class="text-primary my-3 ml-2">
      <h5 class="font-weight-bolder" style="font-size: x-large;">
        {{ $t('CategoryPage.magazines') }}
      </h5>
    </div>

    <div class="splide magazineSplide newFeatureSlider" aria-label="Slider for magazines">
      <div class="sands-article-vueslidercontainer splide__track">
        <div class="splide__list">
          <div v-for="(magazine, i) in magazines" :key="i" class="splide__slide rounded-corners-10 bg-white pl-3">
            <div>
              <div class="d-flex feature-detail-article-column flex-column flex-md-row feature-detail my-4 px-4 pr-5">
                <div class="col-8 col-md-5 p-0">
                  <div v-if="magazine.cover && magazine.cover.xxx" class="rounded">
                    <img class="img-cover" :src="magazine.cover.xxx" loading="lazy" alt="magazine cover">
                  </div>
                </div>
                <div class="col-12 col-md-7 px-0 px-md-3">
                  <div class="mb-2">
                    <h3 v-if="magazine.coverStory" class="d-none d-md-block text-primary">
                      <a :href="constructCourseURL(magazine)">
                        {{ magazine.coverStory }}
                      </a>
                    </h3>
                  </div>
                  <div>
                    <div v-for="(article, i) in magazine.articles.slice(0, 4)" :key="i">
                      <div class="single-article-reference-display d-md-block p-2 p-md-0">
                        <div>
                          <a :href="constructCourseURL(article)" class="col-9 p-0">
                            <div v-if="article.name" class="font-weight-bold mt-lg-0 text-primary article-title">
                              {{ article.name }}
                            </div>
                            <p v-if="article.subtitle" class="mb-0 text-dark article-description">
                              {{ article.subtitle }}
                            </p>
                          </a>
                        </div>
                        <hr class="divider">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Splide from '@splidejs/splide';
import CONCORD_QUERIES from "../../services/concord_queries.js";
import helperFunction from "../../services/helperfunctions.js";
import { watch } from 'vue';
import useElementVisible from "../../services/elementVisibilityService.js";
import axios_queries from '../../services/axios_queries.js';

export default {
  name: "categoryMagazine",
  props: {
    settingsPerm: Object,
  },
  data() {
    return {
      isLoading: false,
      magazines: false,
      loadMorePossible: true,
      isDevMioActive: false,
      currentPage: 1,
      metaCount: 0,
      firstTimeInViewport: true,
      initialDataLoaded: false,
    }
  },

  created() {
    this.isLoading = true;
    setTimeout(() => {
      this.box1Ref = document.getElementById('magazineLoadingBox');

      if (this.box1Ref) {
        const isVisible = useElementVisible(this.box1Ref);
        if (isVisible && isVisible.value && isVisible.value == true) {
          this.firstTimeInViewport = false;
          this.loadInitialData();
        }

        watch(isVisible, (newValue) => {
          if (this.firstTimeInViewport && isVisible && newValue === true) {
            this.firstTimeInViewport = false;
            this.loadInitialData();
          }
          // Do something when isVisible changes
        });
      }
      this.emitter.on('articlesProcessed', () => {
        this.firstTimeInViewport = false;
        this.loadInitialData();
      });
    }, 500);
    if (this.settingsPerm && this.settingsPerm.isDevMioActive) {
      this.isDevMioActive = this.settingsPerm.isDevMioActive;
    }
  },

  methods: {

    loadInitialData() {
      if (!this.initialDataLoaded) {
        this.initialDataLoaded = true;
        let catMagazineLoadingParams = {
          page: 1,
          pagesize: 12,
          querystring: this.settingsPerm.cat,
          transientKey: this.settingsPerm.cat + '-cat-depending-magazine-vue',
          query: "cat-depending-magazine-vue",
          url: this.settingsPerm.ajaxUrl+'/wp-content/uploads/catpages/'+this.settingsPerm.cat+'-cat-depending-magazine-vue.json'
        };
        axios_queries.loadPublicData(catMagazineLoadingParams).then((concordData) => {
          if (concordData && concordData != null && concordData != undefined && concordData != '') {
            if (concordData.advancedSearch && concordData.advancedSearch.issues && concordData.advancedSearch.issues.Issues && concordData.advancedSearch.issues.Issues.length) {
              this.displayMagazines(concordData.advancedSearch.issues.Issues);
            } else {
              this.isLoading = false;
              this.emitter.emit('MagazineProcessed', true);
            }
          } else {
            this.isLoading = false;
            this.emitter.emit('MagazineProcessed', true);
          }
        })
      }
    },

    displayMagazines(magazines) {
      this.magazines = magazines;
      this.isLoading = false;
      this.mount_splide();
    },

    async loadMoreData() {
      // Make an API call to fetch more data
      const nextPage = this.currentPage + 1;
      let variablesForQuery = {
        page: nextPage,
        pagesize: 12,
        querystring: this.settingsPerm.cat,
      };
      let graphqlQuery = CONCORD_QUERIES.CAT_SPECIFIC_MAGAZINE;
      let concordData = await axios_queries.getMoreData(graphqlQuery,variablesForQuery);
      if (concordData && concordData.advancedSearch && concordData.advancedSearch.issues && concordData.advancedSearch.issues.Issues && concordData.advancedSearch.issues.Issues.length) {
        const newmagazines = concordData.advancedSearch.issues.Issues;
        // console.log('New magazines',newmagazines);
        this.magazines = [...this.magazines, ...newmagazines];
        // console.log('magazines',this.magazines);
        this.isLoading = false;
        this.currentPage = nextPage;
        this.mount_splide();
      }
    },

    constructCourseURL(concordObject) {
      return helperFunction.sandsConstructRealUrl(concordObject);
    },

    addMovedEventListener() {
      this.splide.on('moved', (newIndex) => {
        const lastCardIndex = newIndex + this.splide.options.perPage;
        // console.log('lastcardindex', lastCardIndex);
        // console.log('lenght', this.magazines.length);

        if (lastCardIndex === this.magazines.length - 2 && this.magazines.length > this.metaCount) {
          this.loadMoreData();
        }
      });
    },


    mount_splide: function () {
      let thiz = this;
      setTimeout(function () {
        if (!thiz.splide) {
          thiz.splide = new Splide('.magazineSplide', {
            classes: {
              prev: 'splide__arrow--prev prev prev-magazine-slide xx',
              next: 'splide__arrow--next next next-magazine-slide xxx',
              arrow: 'splide__arrow xxxx',
            },
            perPage: 2,
            perMove: 1,
            rewindByDrag: true,
            gap: '1rem',
            breakpoints: {
              1024: {
                perPage: 2,
                padding: {
                  right: '0rem',
                  left: '0rem',
                }
              },
              991: {
                perPage: 1,
                padding: {
                  right: '0rem',
                  left: '0rem',
                }
              },
              767: {
                perPage: 1,
                padding: {
                  right: '0rem',
                  left: '0rem',
                }
              },
            },
            rewind: false,
            pagination: false,
            padding: {
              right: '0rem',
              left: '0rem',
            }
          });
          thiz.splide.mount();
          thiz.addMovedEventListener(); // Add event listener
        } else {
          thiz.splide.refresh(); // Refresh the existing Splide instance
        }
      }, 100);
    },
  },


};
</script>
<style>


.article-title {
  font-size: 17px;
}

.article-description {
  font-size: 15px;
}

.divider {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}
</style>